<template>
    <div class="footer">
       Tous droits réservés à qui de droit. ©® Toutes marques présentes sont enregistrées auprès d'autorités probablement compétentes.
    </div>
</template>

<script>
export default {
}
</script>

<style>
    .footer {
        background: #272727;
        width: 100%;
        min-height: 10vh;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        padding: 1rem;
    }
</style>
